import { RadioCard, HStack, Text } from "@chakra-ui/react";

import { ProductDetails } from "helpers/fakeData";
import { useCallback, useLayoutEffect } from "react";

interface Props {
  product: ProductDetails;
  onSelectSize: (size: string) => void;
}

const SizePicker = ({ product, onSelectSize }: Props) => {
  const sizes = product.sizes ?? [];
  const defaultSize = sizes.length > 0 ? sizes[0] : undefined;

  const handleSelectSize = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      onSelectSize(e.target.value);
    },
    [onSelectSize]
  );

  useLayoutEffect(() => {
    if (defaultSize != null) {
      onSelectSize(defaultSize);
    }
  }, []);

  if (sizes.length === 0) {
    return null;
  }

  return (
    <RadioCard.Root
      orientation="horizontal"
      align="center"
      justify="center"
      maxW="lg"
      defaultValue={defaultSize}
      onChange={handleSelectSize}
    >
      <RadioCard.Label>Size</RadioCard.Label>
      <HStack align="stretch">
        {sizes.map((size) => (
          <RadioCard.Item key={size} value={size} cursor="pointer">
            <RadioCard.ItemHiddenInput />
            <RadioCard.ItemControl>
              <Text>{size}</Text>
            </RadioCard.ItemControl>
          </RadioCard.Item>
        ))}
      </HStack>
    </RadioCard.Root>
  );
};

export default SizePicker;
